import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import CloseIcon from '@mui/icons-material/Close'
import { Alert, IconButton } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { finishWarningAlert } from 'redux/alert/alert-actions'
import { RootState } from 'redux/store'
import { IMAGES_PATH, useTheme } from 'themes'

import { newFormThemeOverrides } from '../../styles'

const warningImg = IMAGES_PATH('/alert-warning.svg')

const AlertWarningComponent = () => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const { warningAlertText, warningAlert } = useSelector((state: RootState) => state.alert)

    const handleClose = () => {
        dispatch(finishWarningAlert())
    }

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Collapse in={warningAlert} timeout={500}>
                        <Alert
                            icon={false}
                            className="warning"
                            action={
                                <IconButton className="alertDismiss" aria-label="close" color="inherit" size="small" onClick={handleClose}>
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            <div className="iconBox">
                                <img className="iconImg" src={warningImg} alt={t('Alert.Warning')} />
                            </div>
                            <div className="message">
                                <span className="type">{t('Alert.Warning')}:</span>
                                <span className="text">{warningAlertText}</span>
                            </div>
                        </Alert>
                    </Collapse>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default AlertWarningComponent
